<navigation-button
  scsStopPropagation
  (click)="openListItems(node.list.id)"
  [indent]="indent"
  [expandable]="node.children.length > 0"
  [(expanded)]="expanded"
  [disabled]="!canManage"
  (expandedChange)="onExpandedChange($event)">
  <ng-container icon>
    <scs-svg-icon name="list"></scs-svg-icon>
  </ng-container>

 {{ node.list.name }}

  <ng-container addons>
    <navigation-button-addon *ngIf="loading$ | async">
      <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon>
    </navigation-button-addon>
  </ng-container>

  <ng-template #expandedTemplate>
    <navigation-list
      *ngFor="let node of node.children; trackBy: listTrackByFn"
      [indent]="(indent||0)+1"
      [level]="level+1"
      [maxDepth]="maxDepth-1"
      [collection]="collection"
      [node]="node"
      [canManage]="canManage"
      [listExplorerMode]="listExplorerMode"
      (onCreateList)="onCreateList.emit($event)">
    </navigation-list>
  </ng-template>
  
</navigation-button>
